<template>
  <a-drawer
    :title="title"
    :width="600"
    :visible="open"
    :closable="true"
    @close="onClose"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('技能管理.技能名称')" prop="skillName">
        <a-input v-model="form.skillName" :maxLength="50" />
      </a-form-model-item>

<!--      <a-form-model-item :label="$t('技能管理.技能图标')" prop="skillIcon">-->
<!--        <OssUploadSingle v-model="form.skillIcon" type="img" :maxSize="200"></OssUploadSingle>-->
<!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('技能管理.技能类型')" prop="skillType">
        <a-select v-model="form.skillType">
          <a-select-option :value="1">{{ $t('技能管理.通用技能') }}</a-select-option>
          <a-select-option :value="2">{{ $t('技能管理.废品技能') }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('技能管理.排序')" prop="sort">
        <a-input-number v-model="form.sort" :min="0" />
      </a-form-model-item>

      <a-form-model-item :label="$t('技能管理.状态')" prop="status">
        <a-radio-group v-model="form.status">
          <a-radio :value="1">{{ $t('通用.文本.启用') }}</a-radio>
          <a-radio :value="0">{{ $t('通用.文本.禁用') }}</a-radio>
        </a-radio-group>
      </a-form-model-item>

<!--      <a-form-model-item :label="$t('技能管理.备注')" prop="remark">-->
<!--        <a-textarea v-model="form.remark" :rows="3" :maxLength="200" />-->
<!--      </a-form-model-item>-->
    </a-form-model>
    <div class="drawer-footer">
      <a-button :loading="submitLoading" type="primary" @click="submitForm">{{ $t('通用.按钮.保存') }}</a-button>
      <a-button @click="onClose">{{ $t('通用.按钮.取消') }}</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getSkill, addSkill, editSkill } from '@/api/homeworker/skill'
import OssUploadSingle from '@/components/OssUploadSingle'

export default {
  name: 'CreateForm',
  components: { OssUploadSingle },
  data() {
    return {
      title: '',
      open: false,
      submitLoading: false,
      formType: 1,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      form: {
        id: null,
        skillName: null,
        skillIcon: null,
        skillType: 1,
        sort: 0,
        status: 1,
        remark: null
      },
      rules: {
        skillName: [{ required: true, message: this.$t('技能管理.技能名称') + this.$t('通用.文本.不能为空'), trigger: 'blur' }],
        skillType: [{ required: true, message: this.$t('技能管理.技能类型') + this.$t('通用.文本.不能为空'), trigger: 'change' }]
      }
    }
  },
  methods: {
    handleAdd() {
      this.reset()
      this.formType = 1
      this.title = this.$t('技能管理.新增技能')
      this.open = true
    },
    handleUpdate(row) {
      this.reset()
      this.formType = 2
      this.title = this.$t('技能管理.修改技能')
      getSkill(row.id).then(response => {
        this.form = response.data
        this.open = true
      })
    },
    reset() {
      this.form = {
        id: null,
        skillName: null,
        skillIcon: null,
        skillType: 1,
        sort: 0,
        status: 1,
        remark: null
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id) {
            editSkill(this.form).then(() => {
              this.$message.success(this.$t('通用.文本.修改成功'))
              this.onClose()
              this.$emit('ok')
            }).finally(() => { this.submitLoading = false })
          } else {
            addSkill(this.form).then(() => {
              this.$message.success(this.$t('通用.文本.新增成功'))
              this.onClose()
              this.$emit('ok')
            }).finally(() => { this.submitLoading = false })
          }
        }
      })
    },
    onClose() {
      this.open = false
    }
  }
}
</script>
